module.exports = __webpack_public_path__ + "static/media/14-60.ab47fefe.svg";